// @flow

/****
 * Exposes the GraphQL type definitions for all union and interface types in our GraphQL schema.
 *
 * This is used to provide a custom `IntrospectionFragmentMatcher` to our GraphQL clients,
 * so they are able to do result validation and fragment-matching for union and interface fields.
 *
 * For more information, see the [Fragments on unions and interfaces](https://www.apollographql.com/docs/react/advanced/fragments/#fragments-on-unions-and-interfaces)
 * section of the Apollo docs.
 */

// We're purposefully NOT using ES6 modules here so this can be consumed from build-tools
// that don't support ES6 module syntax, like the eslint config file.
module.exports = require('./__generated__/graphql-fragment-types-manifest.json');
